import axios from "axios";
import { useEffect, useState } from "react";

export default function EditQuestion(props){ 
    
    const id =props.id;
    const [data, setData]=useState([]);
    const [question, setQuestion]=useState([]);
    
    function getData(){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/course/open/getCourses`)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
    }
     function getQuestion(id){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/question/secured/getQuestion/`+id)
        .then(result=>setQuestion(result.data))
        .catch(err=>console.log(err));
    }
    useEffect(()=>getData(),[]);
     useEffect(()=>getQuestion(id),[id]);
    function submitHandler(e){   
        e.preventDefault();
        const obj = new FormData(e.target);
        const data = Object.fromEntries(obj.entries()); 
        axios.put(`${process.env.REACT_APP_BASE_URL}api/question/secured/updateQuestion`,data)
        .then(result=>{alert("Edit Successfully!");window.location.href="/question"})
        .catch(err=>console.log(err));
    }

    return(<div className="form-container container">
            <button className="btn btn-danger" style={{float:"right"}} onClick={()=>props.event(false)}>X</button>
        <div className="text-center">
            <h2>Edit Question</h2>
        </div><hr />
        <div className="form">
            <form onSubmit={submitHandler}>
                <div className="row">
                    <div className="col col-sm-6">
                        <input type="hidden" name="id" defaultValue={question.id} />
                        <div>
                            <textarea className="form-control" name="question" rows={10} placeholder="Question" defaultValue={question.question} required></textarea>
                        </div>
                         <div>
                            <input className="form-control" type="text" name="answer" placeholder="Answer" defaultValue={question.answer} required />
                        </div>
                       
                    </div>
                    <div className="col col-sm-6">
                         <div>
                            <input className="form-control" type="text" name="option1" placeholder="Option1" defaultValue={question.option1} required />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="option2" placeholder="option2" defaultValue={question.option2} required />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="option3" placeholder="option3" defaultValue={question.option3} required />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="option4" placeholder="option4" defaultValue={question.option4} required />
                        </div>
                        <div>
                           <select name="courseId" className="form-select" required>
                          {data.map((course)=>
                            <option value={course.id} selected={course.id===question.courseId}>{course.name}</option>
                          )}
                        </select>
                        </div>
                        <div>
                            <button className="btn btn-color form-control">Submit</button>
                        </div> 
                    </div>
                </div> 
            </form>
        </div>
    </div>);
}